import React from 'react';
import Accordion from 'components/Accordion';
import DatePicker from 'components/DatePicker';
import { CultureIndexAreaMap } from 'types/Meteorology/Agro/CultureIndex/Area/map';
import useForecastPeriod from 'hooks/Meteorology/Agro/CultureIndex/Area/useForecastPeriod';

export default function Period({ map }: {
  map: CultureIndexAreaMap,
}) {
  const {
    periodStart,
    periodEnd,
    changePeriod,
    availablePeriod,
  } = useForecastPeriod(map);

  return (
    <Accordion.Item eventKey="period" id={`culture-index-period-${map.id}`}>
      <Accordion.Header>Período de previsão</Accordion.Header>
      <Accordion.Body>
        <DatePicker
          inline
          onChange={changePeriod}
          startDate={periodStart}
          endDate={periodEnd}
          includeDates={availablePeriod}
          selectsRange
        />
      </Accordion.Body>
    </Accordion.Item>
  );
}
